import React from 'react';
import { Button } from '@/components/ui/button';
import { BarChart3, Cpu, Users } from 'lucide-react';

const EcommerceCallToAction = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-blue-600 to-indigo-800 text-white">
      <div className="container">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
                Deine E-Commerce Vision 2025+ umsetzen
              </h2>
              <p className="text-lg opacity-90 mb-8">
                Mit über 10 Jahren Erfahrung in der Entwicklung digitaler Handelsplattformen liefern wir nicht nur Shops, 
                sondern echte Verkaufsmaschinen, die dein Business auf das nächste Level heben.
              </p>
              
              <div className="space-y-4 mb-10">
                <div className="flex items-start">
                  <div className="rounded-full bg-white/10 p-2 mr-4">
                    <Users className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">Strategie-Beratung</h3>
                    <p className="opacity-80">Kostenfreies Erstgespräch mit unseren E-Commerce-Experten</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="rounded-full bg-white/10 p-2 mr-4">
                    <BarChart3 className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">Plattform-Analyse</h3>
                    <p className="opacity-80">Technologie-unabhängige Empfehlung der optimalen Lösung</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="rounded-full bg-white/10 p-2 mr-4">
                    <Cpu className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">Maßgeschneiderte Umsetzung</h3>
                    <p className="opacity-80">Entwicklung deiner individuellen E-Commerce-Plattform</p>
                  </div>
                </div>
              </div>
              
              <Button asChild size="lg" className="bg-white hover:bg-gray-100 text-blue-800 font-medium px-8 py-6 text-lg rounded-full">
                <a href="#contact">Jetzt kostenloses Strategie-Gespräch vereinbaren</a>
              </Button>
            </div>
            
            <div className="lg:ml-auto relative">
              <div className="bg-gradient-to-br from-blue-300/10 to-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/10">
                <div className="text-center mb-6">
                  <span className="inline-block bg-white/20 px-4 py-1 rounded-full text-sm font-medium mb-4">
                    Deine Vorteile mit uns als Agentur
                  </span>
                  <h3 className="text-2xl font-bold">Mehr als ein Online-Shop</h3>
                </div>
                
                <ul className="space-y-4">
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-green-400 mr-3"></div>
                    <span>Conversion-Rate-Optimierung mit nachweisbarem ROI</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-green-400 mr-3"></div>
                    <span>Zukunftssichere Technologie ohne Vendor Lock-in</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-green-400 mr-3"></div>
                    <span>Performance-optimierte Shops für bessere Rankings</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-green-400 mr-3"></div>
                    <span>Nahtlose Integration in bestehende System-Landschaft</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-green-400 mr-3"></div>
                    <span>Persönlicher Support & Betreuung nach Launch</span>
                  </li>
                </ul>
                
                <div className="mt-8 text-center">
                  <span className="text-2xl font-bold">+38%</span>
                  <p className="text-sm opacity-80">durchschnittliche Conversion-Steigerung</p>
                </div>
              </div>
              
              <div className="absolute -top-4 -right-4 bg-gradient-to-br from-amber-400 to-amber-600 text-amber-950 text-sm font-bold py-2 px-4 rounded-full rotate-6 shadow-lg">
                Nachhaltiger Erfolg garantiert
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EcommerceCallToAction; 